import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { withRouter } from 'react-router';
import * as SurveyStateController from '../../../store/StateControllers/Survey/SurveyStateController';
import "./../styles.css";
import { SurveyProps } from '../CreateAndEditSurveys';
import { ToxnotSignInRequiredComponent } from '../../core/BaseApplicationComponents/ToxnotSignInRequiredComponent';
import { TeamRole } from '../../../store/Models/UserContext';
import CheckBox from '../../core/CheckBox';


class CreateAndEditSurveyMessagesPage extends ToxnotSignInRequiredComponent<SurveyProps>{
    protected renderConcreteComponent() {
        return (
            <div className="grouped-data">
                <div className="group">
                    <div className="title">
                        {this.localizeString("Email Settings")}
                    </div>
                    <div className="content">
                        <div className="tn-section-row">
                            <div className="tn-section-col-5">
                                <div className="form-group">
                                    <label>{this.localizeString("Requestor Name")}</label>
                                    <input type="text" id="from-name" value={this.props.surveyRequest.fromName} onChange={e => this.props.setSurveyRequestData({ fromName: e.target.value })} className="form-control" disabled={!this.props.appServices.userContext?.isEditor} />
                                </div>
                            </div>
                            <div className="tn-section-col-6 tn-section-col-offset-1">
                                <div className="form-group">
                                    <label>{this.localizeString("Requestor Email")}</label>
                                    <input list="verified-email-addresses" id="from-address" type="text" value={this.props.surveyRequest.fromEmailAddress} onChange={e => this.props.setFromEmailAddress(e.target.value)} className="form-control" disabled={!this.props.appServices.userContext?.isEditor} />
                                    <datalist id="verified-email-addresses">
                                        {this.props.surveyMetadata.connectedEmailUsers.map((v, i) =>
                                            <option key={i} value={v.sendingEmailAddress}>{v.userName}</option>)}
                                        {this.props.surveyMetadata.verifiedEmailUsers.map((v, i) => // connected users were removed from the verified list
                                            <option key={i} value={v.sendingEmailAddress}>{v.userName}</option>)}
                                    </datalist>
                                </div>
                            </div>
                        </div>
                        {this.props.surveyMetadata.verifiedEmailUsers.some((v, i) => v.emailAddress === this.props.surveyRequest.fromEmailAddress)
                            ? (
                                <div className="tn-section-row">
                                    <div className="alert alert-success">
                                        {this.localizeString("This survey will be sent directly from the verified email account")} {this.props.surveyRequest.fromEmailAddress}
                                    </div>
                                </div>
                            )
                            : (this.props.surveyMetadata.connectedEmailUsers.some((v, i) => v.sendingEmailAddress === this.props.surveyRequest.fromEmailAddress) ?
                                (
                                    <div className="tn-section-row">
                                        <div className="alert alert-success">
                                            {this.localizeString("This survey will be sent directly from the connected email account")} {this.props.surveyRequest.fromEmailAddress}
                                        </div>
                                    </div>
                                )
                                : (<div className="tn-section-row">
                                    <div className="alert alert-warning unverified-email-warning">
                                        <p>
                                            {this.localizeString("You are sending this survey with an unverified email address. The survey will be sent from noreply@3eco.com.")}
                                        </p>
                                        <p className="no-verified-email">
                                            {this.localizeString("If you would like it to come from your email address, please connect your email address in the profile page.")}
                                            {" "}
                                            <a href="/Account/Profile">{this.localizeString("Go to the Profile page")}</a>
                                        </p>
                                    </div>
                                </div>
                                ))
                        }
                        <div className="form-group">
                            <label>{this.localizeString("CC Emails")}</label>
                            <input type="text" id="cc-email-addresses" value={this.props.surveyRequest.ccEmailList.join(",")} onChange={e => this.props.setSurveyRequestData({ ccEmailList: e.target.value.split(",") })} className="form-control" placeholder={this.localizeString("Comma seperated email addresses")} disabled={!this.props.appServices.userContext?.isEditor} />
                        </div>
                        <div className="form-group">
                            <label>{this.localizeString("Subject")}</label>
                            <input type="text" id="email-subject" value={this.getLanguageMapValue("subject")} onChange={e => this.setLanguageMap("subject", e.target.value)} className="form-control" disabled={!this.props.appServices.userContext?.isEditor} />
                        </div>
                        <div className="form-group">
                            <div className="checkbox">
                                <label>
                                    <input type="checkbox" checked={this.props.surveyRequest.useManufacturerLogo} onChange={e => this.props.setSurveyRequestData({ useManufacturerLogo: !this.props.surveyRequest.useManufacturerLogo })} disabled={!this.props.appServices.userContext?.isEditor} /> {this.localizeString("Include Company Logo")}
                                </label>
                            </div>
                        </div>
                        <div className="form-group">
                            <label>{this.localizeString("Custom Email Message")}</label><span className="language-tag">{this.props.appServices.getLocalizedDisplayNameForCultureName(this.props.surveyUi.currentLanguage)}</span>
                            <div className="alert alert-info" role="alert">
                                <p><em>{this.localizeString("The text that would be displayed in the email to the supplier. If left empty, then by default, the Request Instructions are included in the supplier's survey activation email.")}</em></p>
                            </div>
                            <textarea id="email-message" value={this.getLanguageMapValue("message")} onChange={e => this.setLanguageMap("message", e.target.value)} className="form-control" rows={5} placeholder="Message Body" disabled={!this.props.appServices.userContext?.isEditor} />
                        </div>
                    </div>
                </div>
                <div className="group">
                    <div className="title">
                        {this.localizeString("Other Settings")}
                    </div>
                    <div className="content">
                        <CheckBox checkboxLabelText={this.props.appServices.localizeString("Include Attestation Letter")}
                            checked={this.props.surveyRequest.includeAttestationLetter}
                            onValueChange={(value:boolean) => this.props.setSurveyRequestData({ includeAttestationLetter: value })}
                            isDisabled={false}>
                        </CheckBox>
                    </div>
                    <div className="content">
                        <div className="form-group">
                            <label>Request Instructions </label> <span className="language-tag">{this.props.appServices.getLocalizedDisplayNameForCultureName(this.props.surveyUi.currentLanguage)}</span>
                            <div className="alert alert-info" role="alert">
                                <p><em>{this.localizeString("Request instructions give suppliers directions on how and why to respond to your survey request. They are displayed to the supplier when they activate the survey and while editing the response.")}</em></p>
                            </div>
                            <textarea id="request-instructions" value={this.getLanguageMapValue("requestInstructions")} onChange={e => this.setLanguageMap("requestInstructions", e.target.value)} className="form-control" rows={5} placeholder="Instructions for supplier's response." disabled={!this.props.appServices.userContext?.isEditor} />
                        </div>
                        <div className="form-group">
                            <label>{this.localizeString("Completion Instructions")}</label><span className="language-tag">{this.props.appServices.getLocalizedDisplayNameForCultureName(this.props.surveyUi.currentLanguage)}</span>
                            <textarea id="completion-instructions" value={this.getLanguageMapValue("completionInstructions")} onChange={e => this.setLanguageMap("completionInstructions", e.target.value)} className="form-control" rows={5} placeholder={this.localizeString("Instructions displayed to supplier when the survey is completed")} disabled={!this.props.appServices.userContext?.isEditor} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    // ===============================================================================

    protected override getDisallowedRoles() {
        return [TeamRole.Marketing];
    }

    //=============Message & Reminders=================================

    private getLanguageMapValue(item: string) {
        if (this.props.surveyUi.currentLanguage === this.props.surveyRequest.nativeLanguage) {
            switch (item) {
                case "subject":
                    return this.props.surveyRequest.emailSubject;
                case "message":
                    return this.props.surveyRequest.emailMessage;
                case "requestInstructions":
                    return this.props.surveyRequest.requestInstructions;
                case "completionInstructions":
                    return this.props.surveyRequest.completionInstructions;
            }
        } else {
            switch (item) {
                case "subject":
                    return this.props.surveyRequest.languageToEmailSubjectMap[this.props.surveyUi.currentLanguage] || "";
                case "message":
                    return this.props.surveyRequest.languageToEmailMessageMap[this.props.surveyUi.currentLanguage] || "";
                case "requestInstructions":
                    return this.props.surveyRequest.languageToRequestInstructionsMap[this.props.surveyUi.currentLanguage] || "";
                case "completionInstructions":
                    return this.props.surveyRequest.languageToCompletionInstructionsMap[this.props.surveyUi.currentLanguage] || "";
            }
        }
    }

    // ===============================================================================

    private setLanguageMap(item: string, value: string) {
        const key = this.props.surveyUi.currentLanguage;
        if (key === this.props.surveyRequest.nativeLanguage) {
            switch (item) {
                case "subject":
                    return this.props.setSurveyRequestData({ emailSubject: value });
                case "message":
                    return this.props.setSurveyRequestData({ emailMessage: value });
                case "requestInstructions":
                    return this.props.setSurveyRequestData({ requestInstructions: value });
                case "completionInstructions":
                    return this.props.setSurveyRequestData({ completionInstructions: value });
            }
        } else {
            switch (item) {
                case "subject":
                    return this.props.setLanguageMap("languageToEmailSubjectMap", key, value);
                case "message":
                    return this.props.setLanguageMap("languageToEmailMessageMap", key, value);
                case "requestInstructions":
                    return this.props.setLanguageMap("languageToRequestInstructionsMap", key, value);
                case "completionInstructions":
                    return this.props.setLanguageMap("languageToCompletionInstructionsMap", key, value);
            }
        }
    }
}


export default connect(
    (state: ApplicationState) => ({ ...state.createAndEditSurveysState, appServices: state.appServices }),
    SurveyStateController.actionCreators
)(withRouter(CreateAndEditSurveyMessagesPage) as any);